const redirectUrl = {
    local: 'http://localhost:3000/dashboard',
    dev: 'https://nts-order-monitoring-dev.nike.net/dashboard',
    qa: 'https://nts-order-monitoring-qa.nike.net/dashboard',
    stg: 'https://nts-order-monitoring-stg.nike.net/dashboard',
    prod: 'https://nts-order-monitoring.nike.net/dashboard'
};

const oktaBaseUrl = {
    local: 'https://nike-qa.oktapreview.com',
    dev: 'https://nike-qa.oktapreview.com',
    qa: 'https://nike-qa.oktapreview.com',
    stg: 'https://nike-qa.oktapreview.com',
    prod: 'https://nike.okta.com'
};

const issuer = {
    local: 'ausa0mcornpZLi0C40h7',
    dev: 'ausa0mcornpZLi0C40h7',
    qa: 'ausa0mcornpZLi0C40h7',
    stg: 'ausa0mcornpZLi0C40h7',
    prod: 'aus27z7p76as9Dz0H1t7'
};

const endpointTokenToType = {
    'local': 'local',
    'dev': 'dev',
    'qa': 'qa',
    'stg': 'stg'
};

function calculateEndpointToken(locationOrigin) {
    if (
        locationOrigin.toLowerCase().includes("localhost")
    ) {
        return 'local';
    }

    return locationOrigin.split('.', 1)[0].split(/[-]+/).pop();
}

export default function getRedirectUrl(locationOrigin) {
    let endpointToken = calculateEndpointToken(locationOrigin);
    const type = endpointTokenToType[endpointToken];
    if(type) {
        return redirectUrl[type];
    } else {
        return redirectUrl['prod'];
    }
}

export function getOktaBaseUrl(locationOrigin) {
    let endpointToken = calculateEndpointToken(locationOrigin);
    const type = endpointTokenToType[endpointToken];
    if(type) {
        return oktaBaseUrl[type];
    } else {
        return oktaBaseUrl['prod'];
    }
}

export function getIssuer(locationOrigin) {
    let endpointToken = calculateEndpointToken(locationOrigin);
    const type = endpointTokenToType[endpointToken];
    if(type) {
        return issuer[type];
    } else {
        return issuer['prod'];
    }
}


// WEBPACK FOOTER //
// ./src/service/redirectUrl.js